/* @flow */
import React from 'react';
import { Alert } from 'antd';
import styles from './Alert.module.pcss';

type Props = {
  message: string,
  description?: string,
  showIcon: boolean,
  onClose?: (data: any) => void,
  type: string,
  closable: boolean,
  alert: Object,
};

const CustomAlert = ({ message, description, showIcon, onClose, type, closable, alert }: Props) => {
  const handleCloseAlert = () => {
    if (onClose) {
      onClose(alert);
    }
    return false;
  };

  return (
    <Alert
      message={message}
      description={description}
      type={type}
      className={styles.errorMessage}
      closable={closable}
      onClose={handleCloseAlert}
      showIcon={showIcon}
    />
  );
};

CustomAlert.defaultProps = {
  description: null,
  onClose: () => {},
};

export default CustomAlert;
